import { registerModule } from '@sas-dvr/ltjs-commons/ltjsEnvironment';
import ICUPackage from './ICUPackage';
import '@sas-dvr/ltjs-commons/lib';
registerModule('sasicu', [ICUPackage]);
